import { styled } from "@pigment-css/react";
import { Skeleton } from "@acto/taskpane/field-sales-2/components/primitives/Skeleton";
import { overlaidMenuClearance } from "@acto/taskpane/field-sales-2/styles/overlaidMenuClearance";

const SkeletonCard = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[24],
  padding: `${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[20]} ${theme.fieldSalesTwo.spacing[32]}`,
  borderRadius: theme.fieldSalesTwo.radius[38],
  background: theme.fieldSalesTwo.colors.surface.glassLight,
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.surface.glassBorderBright}`,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
}));

const SkeletonMoreButton = styled("div")(({ theme }) => ({
  position: "absolute",
  top: theme.fieldSalesTwo.spacing[24],
  right: theme.fieldSalesTwo.spacing[14],
}));

const SkeletonHeaderText = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[6],
  minWidth: 0,
  paddingRight: overlaidMenuClearance({
    menuRightInset: theme.fieldSalesTwo.spacing[14],
    menuButtonWidth: theme.fieldSalesTwo.spacing[50],
    gapToContent: theme.fieldSalesTwo.spacing[10],
    cardPaddingX: theme.fieldSalesTwo.spacing[20],
  }),
}));

const SkeletonRevenueRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[16],
}));

const SkeletonCol = styled("div")(({ theme }) => ({
  flex: "1 1 0",
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[6],
}));

const SkeletonColumns = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.fieldSalesTwo.spacing[4],
}));

interface CustomerSectionSkeletonProps {
  withPrimaryAction?: boolean;
}

export function CustomerSectionSkeleton({ withPrimaryAction = false }: CustomerSectionSkeletonProps) {
  return (
    <SkeletonCard>
      <SkeletonMoreButton>
        <Skeleton.Box width={50} height={50} radius={44} />
      </SkeletonMoreButton>
      <SkeletonHeaderText>
        <Skeleton.Line width={48} height={14} />
        <Skeleton.Line width="90%" height={22} />
      </SkeletonHeaderText>
      <SkeletonRevenueRow>
        <Skeleton.Box width={72} height={48} radius={18} />
        <SkeletonCol>
          <Skeleton.Line width="55%" height={14} />
          <Skeleton.Line width="70%" height={20} />
        </SkeletonCol>
      </SkeletonRevenueRow>
      <SkeletonColumns>
        <SkeletonCol>
          <Skeleton.Line width="60%" height={14} />
          <Skeleton.Line width="40%" height={16} />
        </SkeletonCol>
        <SkeletonCol>
          <Skeleton.Line width="60%" height={14} />
          <Skeleton.Line width="45%" height={16} />
        </SkeletonCol>
      </SkeletonColumns>
      {withPrimaryAction && <Skeleton.Box height={50} radius={44} />}
    </SkeletonCard>
  );
}
